import { get } from '../../helpers/fetch';
import { buildURL } from '../../helpers/urls';

// eslint-disable-next-line import/prefer-default-export
export const getSlideshowImages = () => {
  const url = buildURL('/slideshow/images');
  return get(url);
};
